import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadSTCConfigs () {
    const params = {
      limit: 20,
      offset: 0,
      is_archived: false,
      ordering: '-id'
    }

    return new Promise((resolve, reject) => {
      axiosInstance.get('/stc/configs/', { params }).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
